import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowNavigationDirection, WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {ProjectService} from "../../project/project.service";
import {GlobalDealSettingsService} from "../../global-deal-settings/global-deal-settings.service";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {CADetailsModel, DeliveryOpsInformationModel} from "./delivery-ops-information.model";
import {DisableOrderAcceptanceDialogComponent} from "./disable-order-acceptance-dialog.component";
import {RejectProjectDialogComponent} from "./reject-project-dialog.component";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {GlobalDealClassificationDialogComponent} from "./global-deal-classification-dialog.component";
import {
  billingCycleValuesConst,
  billingFrequencyValuesConst,
  commercialityCodeValuesConst,
  dorMultiPoTypeOptionsConst,
  dorRenewalOptionsConst,
  globalDealValuesConst,
  CONTRACT_ACCOUNT_ERROR_MESSAGES,
  globalDealValues,
} from "../../types/simplify-constants";
import {masterAgreementShortNameLookup, masterAgreementStatusValues} from "../../project/master-agreement-status";
import {SelectItsmContactDialogComponent} from "./select-itsm-contact-dialog.component";
import {ContactService} from "../../contact/contact.service";
import {Subscription} from "rxjs/Subscription";
import {AppSettingsService} from "../../app-settings/app-settings.service";
import {PurchaseOrderService} from "../../purchase-order/purchase-order.service";
import {PurchaseOrderEditCardComponent} from "../purchase-orders/purchase-order-edit-card.component";
import {SupportComponent} from "../../support/support.component";
import {ProjectModel, projectModelFactory} from "../../project/project.model";
import {TARGET_SYSTEM} from "../../helpers/app-constants";
import {DeviceService} from "../../device/device.service";
import * as _ from "lodash";
import {FormGroup, FormBuilder} from "@angular/forms";
import {AssetCOGqlModel} from "../../device/device.gql-model";
import {GlobalDealSettingsModel} from "../../global-deal-settings/global-deal-settings.model";
import {BILL_FROM_STRUCTURE_TYPE, BillFromService} from "../../bill-from/bill-from.service";
import {BillFromValue} from "../../bill-from/bill-from-with-region.model";
import {HasuraGraphqlService} from "../../graphql/hasura-graphql-service";
import {Query} from "../../graphql/query-constant";
import { GlobalDealC2CClassificationDialogComponent } from "./global-deal-c2c-classification-dialog.component";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;

@Component({
  templateUrl: "./delivery-ops-information.template.pug",
  providers: [
    ProjectService,
    PurchaseOrderService,
    GlobalDealSettingsService,
    BillFromService,
    GlobalDealSettingsService,
    HasuraGraphqlService,
  ],
  styles: [
    `
    .card-block-multi-asset{
      padding-top: 0.25rem;
    }
    .card-block-asset{
      overflow-y: auto;
      padding-top: 0.25rem;
      height: auto;
    }
    .card-background-color-onchange{
      color: #fff;
      background-color: #0096d6;
    }
    .card-background-color-default{
      color: inherit;
      background-color: #fff;
    }
    `,
  ],
})
export class DeliveryOpsInformationComponent extends WorkflowStep {
  purchaseOrderSPlitHint = `
No Split - No Purchase Order Split
Solution Split - PO Assignment Exists on Provider Contact (PC)
Offer Split - PO Assignment Exists on the Master Agreement and PC
  `;

  error: Error;
  _isMAActive: boolean = false;
  isMpc: boolean = false;
  POR819_TMC: boolean;
  POR954_TMC: boolean;
  shouldFilterInactiveContact: boolean = false
  por922TMC: boolean;
  set isMAActive(value: boolean) {
    this._isMAActive = value;
    if (value) {
      this.deliveryInfoForm.controls["multiYearPoType"].disable();
      this.deliveryInfoForm.controls["prepaidFieldOnDorTab"].disable();
      this.deliveryInfoForm.controls["legacyDocumentType"].disable();
      this.deliveryInfoForm.controls["legacyDocumentNumber"].disable();
      this.deliveryInfoForm.controls["renewal"].disable();
      this.deliveryInfoForm.controls["previousDocument"].disable();
    } else {
      this.deliveryInfoForm.controls["multiYearPoType"].enable();
      this.deliveryInfoForm.controls["prepaidFieldOnDorTab"].enable();
      this.deliveryInfoForm.controls["legacyDocumentType"].enable();
      this.deliveryInfoForm.controls["legacyDocumentNumber"].enable();
      this.deliveryInfoForm.controls["renewal"].enable();
      this.deliveryInfoForm.controls["previousDocument"].enable();
    }
  }

  get isMAActive(): boolean {
    return this._isMAActive;
  }

  get isCentralizedStructured(): boolean {
    return (this.deliveryInfoForm.get("billFromStructure").value || "") === BILL_FROM_STRUCTURE_TYPE.CENTRALIZED;
  }

  sourceDocumentationLink: string;
  projectId: string;
  customerBpId: string;
  globalDeal: string;
  gdclass: string;
  projectRejected: boolean = false;
  centralToCentralSelected = false;
  projectAllowsFedLLC: boolean = false;
  currentSelectedDeployedCountryValue: string;
  targetSystem: string;
  toggleDorDataVisible: boolean = false;
  toggleBillingCycleVisible: boolean = true;
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";
  itsmCustomerId: string;
  resellerCustomerId: string;
  opportunityId: string;
  itsmAddresses: any = [];
  resellerAddresses: any = [];
  customerAddress: any = [];
  billToAddresses: any = [];
  billToAddressesMap: any = {};
  billToAddressId: string;
  soldToAddresses: any = [];
  soldToAddressesMap: any = {};
  soldToAddressId: string;
  payerAddresses: any = [];
  payerAddressesMap: any = {};
  payerAddressId: string;
  endUserAddresses: any = [];
  endUserAddressesMap: any = {};
  endUserAddressId: string;
  endCustomerAddresses: any = [];
  endCustomerAddressesMap: any = {};
  endCustomerAddressId: string;
  highRadiusErrorMessage: any = {};
  billToContactId: string;
  invoiceContactId: string;
  hpInvoiceContactId: string;
  hpSalesRepContactId: string;
  hpContractAdminContactId: string;
  hpAccDeliveryMgrContactId: string;
  itsmContacts: any = [];
  itsmContactsWithItsmIds: any [];
  itsmContactsWithBpId: any = [];
  nonHpItsmContactsWithBpId: any = [];
  itsmContactsWithBpIdMap: any = {};
  addresstoContractAccount: any = {
    buildToParty: {},
    alternatePayer: {},
  };

  contactTypes = {
    billTo: [],
    accDelMgr: [],
    contractAdmin: [],
    hpInvoice: [],
    sales: [],
    invoice: [],
  };

  // TODO I need to change the pug / ts handling of contacts / addresses here so its struct driven like site details
  settableContacts = Object.freeze({
    billTo: "billTo",
    invoice: "invoice",
    hpInvoice: "hpInvoice",
    sales: "sales",
    empResp: "empResp",
    contractAdmin: "contractAdmin",
    accDelMgr: "accDelMgr",
  });

  contactHumanReadableNames = Object.freeze({
    billTo: "Bill-To Contact",
    invoice: "Invoice Contact",
    hpInvoice: "HP Invoice Contact",
    sales: "HP Sales Rep Contact",
    empResp: "HP Employee Responsible",
    contractAdmin: "HP Contract Admin",
    accDelMgr: "HP Client Manager Contact",
  });

  fieldsToTrim = [
    "csa",
    "saLetter",
    "ampId",
    "opgNumber",
    "customerErpNumber",
    "previousDocument",
    "multiYearTermDuration",
    "legacyDocumentNumber",
  ];

  defaultContractAccountId: string; // NOTE this variable duplicates the one of the form group to set the check mark
  deliveryInfoForm: DeliveryOpsInformationModel = new DeliveryOpsInformationModel();
  billingCycleForm: FormGroup;
  caDetails: CADetailsModel;
  commercialityCodeValues = commercialityCodeValuesConst;
  globalDealClassificationValues = globalDealValuesConst;
  globalDealValues = globalDealValues;
  billingFrequencyValues = billingFrequencyValuesConst;
  filteredBillingFrequencyValues: any;
  filteredBillingFrequencyValuesDefault: {
    id: string;
    value: string;
  }[] = [];

  billingCycleValues = billingCycleValuesConst;
  dorMultiPoTypeOptions = dorMultiPoTypeOptionsConst;
  dorRenewalOptions = dorRenewalOptionsConst;
  masterAgreementStatusValues = masterAgreementStatusValues;

  devices: AssetCOGqlModel[];

  globalDealSettings: GlobalDealSettingsModel;
  assets: {
    monthly: AssetCOGqlModel[];
    ftu: AssetCOGqlModel[];
    ftuBftiad: AssetCOGqlModel[];
    others: AssetCOGqlModel[];
  } = {
    monthly: [],
    ftu: [],
    ftuBftiad: [],
    others: [],
  };

  filteredBillingCycleValues = [];
  coTerminous: boolean = false;
  subscription: Subscription;
  enablePurchaseOrdersFlag: boolean;
  isPmpspProject: boolean = false;
  warningMessage: string = "";
  globalOpportunityId: string = "";
  c2cDeploymentCountry: string = "";
  gdClassificationRequired: boolean;
  por229_1tmc: boolean;
  @ViewChild("contractAccountsForm") contractAccountsForm;

  @ViewChild("purchaseOrderCardComponent") purchaseOrderCardComponent: PurchaseOrderEditCardComponent;

  billingCycleOtherCurrentPage: number = DEFAULT_PAGE;
  billingCycleOtherPageSize: number = DEFAULT_PAGE_LIMIT;
  billingCycleOtherMaxPages: number;
  billingCycleOtherTotalCount: number = 0;;

  billingCycleMonthlyCurrentPage: number = DEFAULT_PAGE;
  billingCycleMonthlyPageSize: number = DEFAULT_PAGE_LIMIT;
  billingCycleMonthlyMaxPages: number;
  billingCycleMonthlyTotalCount: number = 0;

  billingCycleFTUCurrentPage: number = DEFAULT_PAGE;
  billingCycleFTUPageSize: number = DEFAULT_PAGE_LIMIT;
  billingCycleFTUMaxPages: number;
  billingCycleFTUTotalCount: number = 0;
  displayBCFTU: AssetCOGqlModel[];

  billingCycleFTUCurrentPage2: number = DEFAULT_PAGE;
  billingCycleFTUPageSize2: number = DEFAULT_PAGE_LIMIT;
  billingCycleFTUMaxPages2: number;
  billingCycleFTUTotalCount2: number = 0;
  displayBCFTU2: AssetCOGqlModel[];


  displayBCMonthly: AssetCOGqlModel[];
  displayBCOthers: AssetCOGqlModel[];
  displayMessage: boolean = false;
  message: string = "";
  count: number = this.billingCycleOtherTotalCount;
  projectCountry = undefined;
  deployedCountry: any = undefined;
  isRegionIndia = false;
  loadingBillFromList = false;
  POR530: boolean = false;
  POR530_TMC: boolean = true;
  selectedBillFromAccount: BillFromValue = undefined;
  billFromAccountsList: BillFromValue[] = undefined;
  disableCASelection: boolean = false; //used for POR024.1
  selectedCa;
  countries: any[] = [];
  currentStatus;
  currentMAStatus;
  productsNeedingExport: number = 0;
  isFtuWithBFTIAD: boolean = false;
  isFtuWithoutBFTIAD: boolean = false;
  por721: boolean = false;
  requiredFlags = {};
  customerOrResellerBpId: string;

  filterBillingCycleValues() {
    let billingFrequency;
    let billingCycle;
    billingFrequency = this.billingCycleForm.getRawValue().billingFrequencyDefault;
    billingCycle = this.billingCycleForm.getRawValue().billingCycleDefault;
    this.billingCycleForm.get("billingCycleDefault").setValue("");
    this.filterAssets(billingFrequency);
    this.filteredBillingCycleValues = this.billingCycleValues.filter(({scope}) => scope === billingFrequency);
    if (!this.filteredBillingCycleValues.find(it => it.id === billingCycle)) {
      this.deliveryInfoForm.controls["billingCycle"].setValue("");
    }
  }

  filterMontlyBillingCycleAssets() {
    return this.devices.filter(device => device.billingCycle === "M01");
  }

  filterAssets(billingFrequency) {
    this.count = 0;
    let allChecked = true;
    this.message = "";
    if (billingFrequency) {
      if (this.assets.others.length) {
        this.assets.others.forEach((asset) => {
          const assetCard = this.billingCycleForm.get(asset.id);
          if (assetCard.value) {
            this.billingCycleForm.get(asset.id).setValue(false);
          }
        });
      }
      this.assets.others = this.devices.filter(device => device.billingFrequency === billingFrequency);
      if (!this.assets.others.length) {
        const value = this.billingFrequencyValues.filter(bfVal => bfVal.id === billingFrequency)[0].value;
        this.message = `No solutions found with ${value} billing frequency`;
        return;
      }
      const values = [];
      this.assets.others.forEach((asset) => {
        if (asset.billingCycle !== null && asset.billingCycle !== undefined && asset.billingCycle !== "") { asset.style = "card-background-color-onchange"; }
        this.billingCycleForm.addControl(asset.id, this.fb.control(true));
        const value = this.billingCycleForm.get(asset.id).value;
        values.push(value);
        if (!value) allChecked = false;
      });
      this.adjustBCOthersListHelper();
      for (const value of values) {
        if (value) {
          this.count += 1;
        }
      }
      this.billingCycleForm.get("checkUncheck").setValue(allChecked);
      this.displayMessage = this.count === 0;
    }
  }

  checkGlobalDealValue(gdVal) {
    if (gdVal.includes("LC")) {
      this.deliveryInfoForm.get("globalDealClassification").setValue("");
      this.deliveryInfoForm.controls["globalDealClassification"].disable();
      this.gdClassificationRequired = false;
      this.centralToCentralSelected = false;
      this.itsmAddresses = { ...this.customerAddress, ...this.resellerAddresses };
      this.itsmAddresses.endUser = (this.itsmAddresses.endUser || []).filter(it => it.country === this.projectCountry);
      this.endUserAddresses = (this.itsmAddresses.endUser || []).map(it => this.addressHelper(it));
      this.endUserAddressesMap = this.endUserAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
      if (this.itsmAddresses.endUser && this.itsmAddresses.endUser.length === 1) {
        this.endUserAddressId = this.itsmAddresses.endUser[0].id;
        this.deliveryInfoForm.get("endUserAddressId").setValue(this.endUserAddressId);
      }
    } else {
      this.deliveryInfoForm.controls["globalDealClassification"].enable();
      this.gdClassificationRequired = true;
    }
  }

  async checkGlobalDealClassification(gdcVal) {
    if (gdcVal.includes("L2C")) {
      const message = await this.dialogService.showDialog(
        GlobalDealClassificationDialogComponent,
        {backdropColor: "rgba(0, 0, 0, 0.5)"},
      );
      this.centralToCentralSelected = false;
      this.itsmAddresses = { ...this.customerAddress, ...this.resellerAddresses };
      this.itsmAddresses.endUser = (this.itsmAddresses.endUser || []).filter(it => it.country === this.projectCountry);
      this.endUserAddresses = (this.itsmAddresses.endUser || []).map(it => this.addressHelper(it));
      this.endUserAddressesMap = this.endUserAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    }
    if (gdcVal.includes("C2C")) {
      const message = await this.dialogService.showDialog(
        GlobalDealC2CClassificationDialogComponent,
        {backdropColor: "rgba(0, 0, 0, 0.5)"},
      );
      this.centralToCentralSelected = true;
      this.itsmAddresses = { ...this.customerAddress, ...this.resellerAddresses };
      if (this.currentSelectedDeployedCountryValue) {
        this.itsmAddresses.endUser = (this.itsmAddresses.endUser || []).filter((it) => (it.country === this.currentSelectedDeployedCountryValue));
      } else if (this.deployedCountry) {
        this.itsmAddresses.endUser = (this.itsmAddresses.endUser || []).filter(it => it.country === this.deployedCountry);
      } else {
        this.itsmAddresses.endUser = (this.itsmAddresses.endUser || []).filter(it => it.country === this.projectCountry);
      }

      if (this.itsmAddresses.endUser && this.itsmAddresses.endUser.length === 1) {
        this.endUserAddressId = this.itsmAddresses.endUser[0].id;
        this.deliveryInfoForm.get("endUserAddressId").setValue(this.endUserAddressId);
      }
      this.endUserAddresses = (this.itsmAddresses.endUser || []).map(it => this.addressHelper(it));
      this.endUserAddressesMap = this.endUserAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    }
    else {
      this.centralToCentralSelected = false;
      this.itsmAddresses = { ...this.customerAddress, ...this.resellerAddresses };
      this.itsmAddresses.endUser = (this.itsmAddresses.endUser || []).filter(it => it.country === this.projectCountry);
      this.endUserAddresses = (this.itsmAddresses.endUser || []).map(it => this.addressHelper(it));
      this.endUserAddressesMap = this.endUserAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});

    }
  }

  checkUncheckAll(event, individualCheckbox = false) {
    let allChecked = true;
    this.count = 0;
    this.billingCycleForm.get("billingCycleDefault").setValue("");
    if (individualCheckbox) {
      const values = [];

      this.assets.others.forEach((asset) => {
        const value = this.billingCycleForm.get(asset.id).value;
        values.push(value);
        if (!value) allChecked = false;
      });

      for (const value of values) {
        if (value) {
          this.count += 1;
        }
      }
      this.billingCycleForm.get("checkUncheck").setValue(allChecked);
      this.displayMessage = this.count === 0;
      return;
    }
    allChecked = event;
    this.assets.others.forEach((asset) => {
      this.billingCycleForm.get(asset.id).setValue(allChecked);
    });
    allChecked = !allChecked;
    this.displayMessage = allChecked;
    this.count = allChecked ? 0 : this.billingCycleOtherTotalCount;
  }

  assignBillingCycleValue(event) {
    if (event) {
      let updateAtLeastOneBC = false;
      for (const device of this.devices) {
        const id = this.billingCycleForm.get(device.id);
        if (id && id.value) {
          device.billingCycle = this.billingCycleForm.get("billingCycleDefault").value;
          updateAtLeastOneBC = true;
        }
      }
      this.assets.others.forEach((asset) => {
        const assetCard = this.billingCycleForm.get(asset.id);
        if (assetCard.value) {
          this.billingCycleForm.get(asset.id).setValue(false);
          asset.style = "card-background-color-onchange";
        }
      });
      this.billingCycleForm.get("checkUncheck").setValue(false);
      this.count = 0;
      if (!updateAtLeastOneBC) {
        this.billingCycleForm.get("billingCycleDefault").setValue("");
      }
    }
  }

  onListControlsChangeBCMonthly(event) {
    switch (event["key"]) {
      case "page":
        this.billingCycleMonthlyCurrentPage = event["value"];
        break;
      case "limit":
        this.billingCycleMonthlyCurrentPage = DEFAULT_PAGE;
        this.billingCycleMonthlyPageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.adjustBCMonthlyListHelper();
  }

  onListControlsChangeBCFTU(event) {
    switch (event["key"]) {
      case "page":
        this.billingCycleFTUCurrentPage = event["value"];
        break;
      case "limit":
        this.billingCycleFTUCurrentPage = DEFAULT_PAGE;
        this.billingCycleFTUPageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.adjustBCFtuListHelper();
  }

  onListControlsChangeBCFTUWithoutBftiad(event) {
    switch (event["key"]) {
      case "page":
        this.billingCycleFTUCurrentPage2 = event["value"];
        break;
      case "limit":
        this.billingCycleFTUCurrentPage2 = DEFAULT_PAGE;
        this.billingCycleFTUPageSize2 = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.adjustBCFtuWithoutBftiadListHelper();
  }

  adjustBCMonthlyListHelper() {
    const start = (this.billingCycleMonthlyCurrentPage - 1) * +this.billingCycleMonthlyPageSize;
    const end = start + +this.billingCycleMonthlyPageSize;

    this.billingCycleMonthlyTotalCount = this.assets.monthly.length;

    this.billingCycleMonthlyMaxPages = Math.ceil(this.assets.monthly.length / (+this.billingCycleMonthlyPageSize));

    this.displayBCMonthly = [
      ...(this.assets.monthly.slice(start, end)),
    ];
  }

  adjustBCFtuListHelper() {
    const start = (this.billingCycleFTUCurrentPage - 1) * +this.billingCycleFTUPageSize;
    const end = start + +this.billingCycleFTUPageSize;

    this.billingCycleFTUTotalCount = this.assets.ftu.length;

    this.billingCycleFTUMaxPages = Math.ceil(this.assets.ftu.length / (+this.billingCycleFTUPageSize));

    this.displayBCFTU = [
      ...(this.assets.ftu.slice(start, end)),
    ];
  }

  adjustBCFtuWithoutBftiadListHelper() {
    const start = (this.billingCycleFTUCurrentPage2 - 1) * +this.billingCycleFTUPageSize2;
    const end = start + +this.billingCycleFTUPageSize2;

    this.billingCycleFTUTotalCount2 = this.assets.ftuBftiad.length;

    this.billingCycleFTUMaxPages2 = Math.ceil(this.assets.ftuBftiad.length / (+this.billingCycleFTUPageSize2));

    this.displayBCFTU2 = [
      ...(this.assets.ftuBftiad.slice(start, end)),
    ];
  }

  onListControlsChangeBCOthers(event) {
    switch (event["key"]) {
      case "page":
        this.billingCycleOtherCurrentPage = event["value"];
        break;
      case "limit":
        this.billingCycleOtherCurrentPage = DEFAULT_PAGE;
        this.billingCycleOtherPageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.adjustBCOthersListHelper();
  }

  adjustBCOthersListHelper() {
    const start = (this.billingCycleOtherCurrentPage - 1) * +this.billingCycleOtherPageSize;
    const end = start + +this.billingCycleOtherPageSize;

    this.billingCycleOtherTotalCount = this.assets.others.length;

    this.billingCycleOtherMaxPages = Math.ceil(this.assets.others.length / (+this.billingCycleOtherPageSize));

    this.displayBCOthers = [
      ...(this.assets.others.slice(start, end)),
    ];
  }

  syncContactAndAddressIds() {
    const form = this.deliveryInfoForm.getRawValue();
    this.billToAddressId = form.billToAddressId;
    this.soldToAddressId = form.soldToAddressId;
    this.payerAddressId = form.payerAddressId;
    this.endUserAddressId = form.endUserAddressId;
    this.endCustomerAddressId = form.endCustomerAddressId;

    this.billToContactId = form.billToContactId;
    this.invoiceContactId = form.invoiceContactId;
    this.hpInvoiceContactId = form.hpInvoiceContactId;
    this.hpSalesRepContactId = form.hpSalesRepContactId;
    this.hpContractAdminContactId = form.hpContractAdminContactId;
    this.hpAccDeliveryMgrContactId = form.hpAccDeliveryMgrContactId;
  }

  addressHelper(address) {
    // TODO this should come server side at some point
    let menuName = "INVALID";
    if (address.itsmBuilding) {
      menuName = `${address.itsmBuilding} (SITE: ${address.itsmSiteName})`;
    } else if (address.line1) {
      menuName = `Line 1: ${address.line1}, Line 2: ${address.line2 || "<not set>"}`;
    } else if (address.name1) {
      menuName = `Name 1: ${address.name1}, Name 2: ${address.name2 || "<not set>"}`;
    } else if (address.businessPartnerId) {
      menuName = `BP ID: ${address.businessPartnerId}`;
    }
    address.menuName = menuName;

    return address;
  }

  async loadItsmAddresses() {
    // REQUIRES - this.projectId to be set
    // Must be called before the main call to retrieve the project
    Query.ADDRESS.variables.projectId = this.projectId;
    const addressParams = {
      projectId: this.projectId,
      query: Query.ADDRESS,
      uiAction: "PROJECT-ADDRESS",
    };
    let tmcAddress = await this.hasuraGraphqlService.getResponseFromHasura(addressParams);
    this.POR819_TMC = await this.appSettingsService.getFeaturePermission("POR819_TMC", this.projectId);

    if (tmcAddress && tmcAddress.body && tmcAddress.body.data &&
      tmcAddress.body.data.project && tmcAddress.body.data.project.length > 0) {
      tmcAddress = tmcAddress.body.data.project;
      this.customerOrResellerBpId = tmcAddress[0].customerBpId;
      this.customerAddress = tmcAddress[0].customerBuildingAddress;
      this.customerAddress = this.customerAddress.length > 0 ? _.groupBy(this.customerAddress, "types") : {};
      this.deployedCountry = tmcAddress[0].globalDealSettings[0].c2cDeploymentCountry;      

      if (tmcAddress[0].partnerBuildingAddress.length > 0 &&
        (this.targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_PAGE ||
          this.targetSystem === TARGET_SYSTEM.PMPS_PAGE ||
          this.targetSystem === TARGET_SYSTEM.MP_FLEX_RESELL ||
          this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH ||
          this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH)) {
        delete this.customerAddress.billTo;
        delete this.customerAddress.payer;
        this.customerOrResellerBpId = tmcAddress[0].resellerBpId;
        if (this.targetSystem !== TARGET_SYSTEM.PMPS_BILL_THROUGH) {
          delete this.customerAddress.soldTo;
          this.customerOrResellerBpId = tmcAddress[0].resellerBpId;
        }
        delete this.customerAddress.consumables;
        delete this.customerAddress.service;
        this.resellerAddresses = tmcAddress[0].partnerBuildingAddress;
        this.resellerAddresses = this.resellerAddresses.length > 0 ? _.groupBy(this.resellerAddresses, "types") : {};
        delete this.resellerAddresses.endUser;
        delete this.resellerAddresses.endCustomer;
        if (this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) {
          delete this.resellerAddresses.soldTo;
          this.customerOrResellerBpId = tmcAddress[0].customerBpId;
        }
        let payerAddresses = _.sortBy(this.resellerAddresses.payer,"updated_at").reverse();
        payerAddresses = payerAddresses.filter((arr, index, self) =>
          index === self.findIndex((t) => (t.businessPartnerId === arr.businessPartnerId)));
        this.resellerAddresses.payer = payerAddresses;
        let billToAddress = _.sortBy(this.resellerAddresses.billTo,"updated_at").reverse();
        billToAddress = billToAddress.filter((arr, index, self) =>
          index === self.findIndex((t) => (t.businessPartnerId === arr.businessPartnerId)));
        this.resellerAddresses.billTo = billToAddress;
      }
      this.itsmAddresses = { ...this.customerAddress, ...this.resellerAddresses };
    }

    // this.itsmAddresses = await this.projectService.getItsmAddresses(this.projectId);
    this.billToAddresses = (this.itsmAddresses.billTo || []).map(it => this.addressHelper(it));

    this.addresstoContractAccount.buildToParty = [...this.billToAddresses];
    this.billToAddressesMap = this.billToAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});

    if (this.POR819_TMC) {
      this.soldToAddresses = (this.itsmAddresses.soldTo || [])
        .filter(it => it.businessPartnerId === this.customerOrResellerBpId)
        .map(it => this.addressHelper(it));
      if (this.soldToAddresses.length === 1) {
        tmcAddress[0].sold_to_address_id = this.soldToAddresses[0].id;
      }
    } else {
      this.soldToAddresses = (this.itsmAddresses.soldTo || []).map(it => this.addressHelper(it));
    }

    this.soldToAddressesMap = this.soldToAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});

    this.payerAddresses = (this.itsmAddresses.payer || []).map(it => this.addressHelper(it));
    this.addresstoContractAccount.alternatePayer = [...this.payerAddresses];
    this.payerAddressesMap = this.payerAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});

    let country = this.projectCountry || tmcAddress[0].country.countryId;
    if (tmcAddress[0].globalDealClassification === 'C2C') {
      country = this.deployedCountry;
    }
    this.itsmAddresses.endUser = (this.itsmAddresses.endUser || []).filter(it => it.country === country);
    this.endUserAddresses = (this.itsmAddresses.endUser || []).map(it => this.addressHelper(it));
    this.endUserAddressesMap = this.endUserAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});

    this.endCustomerAddresses = (this.itsmAddresses.endCustomer || []).map(it => this.addressHelper(it));
    this.endCustomerAddressesMap = this.endCustomerAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});

    if (this.itsmAddresses.errors && this.itsmAddresses.errors.length) {
      this.error = new Error(this.itsmAddresses.errors.join(".   "));
    }

    if (this.targetSystem === TARGET_SYSTEM.PMPS_SELL_WITH) tmcAddress[0].partnerBuildingAddress = [];

    if (this.requiredFlags && this.requiredFlags["POR695_TMC"]) {

      let soldBpId = [TARGET_SYSTEM.PMPS_PAGE, TARGET_SYSTEM.MIGRATION_IPSO_PAGE, TARGET_SYSTEM.MP_FLEX_RESELL, TARGET_SYSTEM.PMPS_SELL_THROUGH].includes(this.targetSystem) ?
        tmcAddress[0].resellerBpId : tmcAddress[0].customerBpId;
      let soldToOptions: any[] = [];

      let uniquePayers = this.addresstoContractAccount.alternatePayer.filter(payer =>
        soldBpId !== payer.businessPartnerId
      ).map(payer => ({
        menuName: `Payer BPID: ${payer.businessPartnerId}`,
        businessPartnerId: payer.businessPartnerId
      }));
      uniquePayers = uniquePayers.filter((payer, index, self) =>
        index === self.findIndex((p) => p.businessPartnerId === payer.businessPartnerId)
      );
      if (uniquePayers && uniquePayers.length > 0) {
        soldToOptions.push({ menuName: `Account Sold-To BPID: ${soldBpId}`, businessPartnerId: soldBpId });
        soldToOptions.push(...uniquePayers);
        // Add soldToOptions to createContractAccountPresets
        this.addresstoContractAccount.soldToOptions = [...soldToOptions];
      } else {
        this.addresstoContractAccount.soldToOptions = null;
      }
    }

    return tmcAddress;
  }

  setItsmContacts(contacts) {
    if (contacts.length) {
      contacts.forEach(contact => contact.name = `${contact.firstName} ${contact.lastName}`);
      this.itsmContacts = contacts;
      this.itsmContactsWithItsmIds = this.itsmContacts.filter(it => it.itsmContactId);
      this.itsmContactsWithBpId = contacts.filter(it => it.businessPartnerId);
      this.nonHpItsmContactsWithBpId = this.itsmContactsWithBpId.filter(it => !it.isHpContact);
      this.itsmContactsWithBpIdMap =
        this.itsmContactsWithBpId.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
      this.buildContactTypes();
    }
  }

  buildContactTypes() {
    for (const contact of this.itsmContactsWithBpId) {
      if (!contact.isHpContact) {
        this.contactTypes.billTo.push(contact);
        this.contactTypes.invoice.push(contact);
      } else if (contact.contactTypes) {
        Object.keys(contact.contactTypes).forEach((type) => {
          if (type !== "billTo" && type !== "invoice" && this.contactTypes[type]) {
            this.contactTypes[type].push(contact);
          }
        });
      }
    }

    const contactTypesArray = Object.keys(this.contactTypes);
    for (const type of contactTypesArray) {
      if (!this.contactTypes[type].length && (type === "billTo" || type === "invoice")) {
        this.contactTypes[type] = this.nonHpItsmContactsWithBpId;
         
       } else if (!this.shouldFilterInactiveContact && !this.contactTypes[type].length) {
        this.contactTypes[type] = this.itsmContactsWithBpId;
    }
  }
}

  async getHpInvoiceContact(contacts) {
    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
      query: Query.CUSTOMER_CONTACTS,
    };
    const contactResponse = await this.hasuraGraphqlService.getResponseFromHasura(params);
    contacts.forEach((itm) => {
      if (itm.contactTypes && itm.contactTypes["hpInvoice"] === true) {
        itm.contactTypes["hpInvoice"] = false;
      }
    });
    const customerContacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    customerContacts.forEach((contact) => {
      if (contact.contactTypes && contact.contactTypes["hpInvoice"] === true) contacts.push(contact);
    });
  }

  async loadItsmContacts() {
    // REQUIRES - this.projectId to be set
    // Must be called before the main call to retrieve the project
    this.POR954_TMC = await this.appSettingsService.getFeaturePermission("POR954_TMC", this.projectId);
    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
    };
    this.shouldFilterInactiveContact = !this.isMAActive && this.POR954_TMC;
    if(this.shouldFilterInactiveContact) {
       await this.projectService.getItsmContacts(this.projectId, false, true);
    }

    if (this.targetSystem === "pmpsp" || this.targetSystem === "mimp" ||
    this.targetSystem === "mpflexr" || this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH ||
    this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) {
      params.query = this.shouldFilterInactiveContact ? Query.PARTNER_CONTACTS_WITH_ACTIVE_FILTER : Query.PARTNER_CONTACTS;
    } else {
      params.query = this.shouldFilterInactiveContact ? Query.CUSTOMER_CONTACTS_WITH_ACTIVE_FILTER : Query.CUSTOMER_CONTACTS;
    }

    const contactResponse = await this.hasuraGraphqlService.getResponseFromHasura(params);

    const contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    // const contacts = await this.projectService.getItsmContacts(this.projectId);

    if (this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) await this.getHpInvoiceContact(contacts);

    this.setItsmContacts(contacts);
    return this.itsmContacts;
  }

  showSupportModal() {
    SupportComponent.showSupportModal(this.dialogService);
  }

  setMpcContactAddress(items, project: ProjectModel, customerBpid: string, field: string) {
    const itemFound = items.find(it => it.businessPartnerId === customerBpid);
    if (itemFound) project[field] = itemFound;
  }

  setMpcData(project: ProjectModel) {
    const {contacts, addresses} = project.mpcContactsAddressesBpids;

    if (addresses.billToCustomerBpid) this.setMpcContactAddress(this.billToAddresses, project, addresses.billToCustomerBpid, "billToAddress");
    if (addresses.payerCustomerBpid) this.setMpcContactAddress(this.soldToAddresses, project, addresses.payerCustomerBpid, "payerAddress");
    if (addresses.endCustomerBpid) this.setMpcContactAddress(this.endUserAddresses, project, addresses.endCustomerBpid, "endUserAddress");

    if (contacts.billToContactBpid) this.setMpcContactAddress(this.contactTypes.billTo, project, contacts.billToContactBpid, "billToContact");
    if (contacts.invoiceContactBpid) this.setMpcContactAddress(this.contactTypes.invoice, project, contacts.invoiceContactBpid, "invoiceContact");
  }

  // Removes extra blank spaces between, at the beginning and the end of a string
  removeExtraSpacesFromForm(fields: string[]) {
    fields.forEach((field) => {
      if (!this.deliveryInfoForm.controls[field]) return;

      const value = this.deliveryInfoForm.controls[field].value;
      if (!value || typeof value !== "string") {
        return;
      }
      const cleanedValue = value.replace(/\s+/g, " ").trim();
      this.deliveryInfoForm.controls[field].setValue(cleanedValue);
    });
  }

  async updateBillingCycle() {
    const errorCollection: string[] = [];
    this.devices.forEach((device) => {
      if (!device.billingCycle) {
        errorCollection.push(device.deviceKey.toString());
      }
    });
    if (errorCollection.length) {
      this.error = new Error(`Solution IDs ${errorCollection.join(", ")} does not have billing cycle selected`);
      return false;
    }
    const status = await this.deviceService.updateAssetBillingCycle(this.projectId, this.devices);
    if (!status.success) {
      this.error = new Error("Updating Billing Cycle to TMC DB failed");
      return false;
    }
    return true;
  }

  async ChangeDeployedCountry(value) {
    value = value.replace(/[^a-zA-Z]/g, "");
    this.currentSelectedDeployedCountryValue = value;
    this.itsmAddresses = { ...this.customerAddress, ...this.resellerAddresses };
    this.itsmAddresses.endUser = (this.itsmAddresses.endUser || []).filter(it => it.country === this.currentSelectedDeployedCountryValue);
    this.endUserAddresses = (this.itsmAddresses.endUser || []).map(it => this.addressHelper(it));
    if (this.itsmAddresses.endUser && this.itsmAddresses.endUser.length === 1) {
      this.endUserAddressId = this.itsmAddresses.endUser[0].id;
      this.deliveryInfoForm.get("endUserAddressId").setValue(this.endUserAddressId);
    }
    this.endUserAddressesMap = this.endUserAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
  }

  @toggleLoading()
  @handleErrors()
  async loadProject() {
    this.loading = true;
    this.billingCycleForm = this.fb.group({
      billingCycleDefault: ["", []],
      billingFrequencyDefault: ["", []],
      checkUncheck: [true, []],
    });
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    this.projectId = this.workflowService.workflowConfig.projectId;
    await this.projectService.getProjectCountry(this.projectId)
      .then((res) => { this.projectCountry = res.countryId; }); // Must before loading ITSM addresses
    let POR229_1_TMC = false;
    let addressResponse;
    let contactResponse;
    [
      this.projectAllowsFedLLC,
      addressResponse,
      contactResponse,
    ] = await Promise.all([
      this.projectService.getFedlLLCAllowedProject(this.projectId),
      this.loadItsmAddresses(),
      this.loadItsmContacts(),
    ]);
    POR229_1_TMC = await this.appSettingsService.getFeaturePermission(
      "POR229-1_TMC",
      this.projectId,
    )
    this.por229_1tmc = POR229_1_TMC;
    // await this.loadItsmContacts(); // Must before project call 
    // await this.loadItsmAddresses(); // Must before project call
    const params: any = `
    id
    isMpc
    itsmCustomerId
    rejected
    coTerminous
    sourceDocumentationLink
    resellerBpId
    customerBpId
    currentMaStatus
    mpcContactsAddressesBpids
    defaultContractAccountId
    orderAcceptance
    orderAcceptanceCompleteDate
    billingFrequency
    billingCycle
    billToAddress
    soldToAddress
    payerAddress
    endUserAddress
    endCustomerAddress
    billToContact
    invoiceContact
    hpInvoiceContact
    hpSalesRepContact
    hpContractAdminContact
    hpAccDeliveryMgrContact
    currency
    companyCodeGroup
    standardCompanyCode
    saLetter
    maStartDate
    coTerminousDate
    legacyReportedDate
    billingStart
    purchaseOrderSplit
    csa
    ampId
    opportunityId
    customerErpNumber
    opgNumber
    vendorContractAccNumber
    commercialityCode
    globalDealClassification
    multiYearTermDuration
    multiYearPoType
    legacyDocumentType
    renewal
    previousDocument
    shipToSplit
    dorData
    initialBillingDate
    billingStart      
    orderAcceptanceDisableReason     
    billingModelSplit
    businessModelSplit
    chargeTypeSplit      
    globalDeal
    podRequired
    endUserSplit
    titleStatusSplit      
    salesOrganization
    enableCatalogPricing
    inadvanceInarrears
    supplyRoutingId
      `;

    // const project = await this.projectService.getProjectById(this.projectId).toPromise();
    // this.projectCountry = project.country.countryId;
    this.globalOpportunityId = addressResponse[0].globalDealSettings.length ?
      addressResponse[0].globalDealSettings[0].globalOpportunityId : null;
    this.c2cDeploymentCountry = addressResponse[0].globalDealSettings.length ?
      addressResponse[0].globalDealSettings[0].c2cDeploymentCountry : null;
    let project: any = this.deliveryInfoForm.constructProject(addressResponse, contactResponse,
      this.globalOpportunityId);
    if (this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) {
      if (addressResponse[0].customerBuildingAddress && addressResponse[0].customerBuildingAddress.length > 0) {
        project.soldToAddress = addressResponse[0].customerBuildingAddress.filter(_types =>
          _types.types === "soldTo").find(_id => _id.id === addressResponse[0].sold_to_address_id);
      } else { project.soldToAddress = []; }
    }
    project = projectModelFactory(project);
    this.globalDealClassificationValues.push(
      {id: "L2C", value: "Local to Central"},
    );
    this.globalDealClassificationValues.splice(this.globalDealClassificationValues.findIndex(a => a.id === "NA"), 1);
    // this.globalDealSettings = await this.globalDealSettingsService.getGlobalDealSettings(this.projectId);
    // this.globalOpportunityId = this.globalDealSettings.globalOpportunityId || "";
    project.globalDeal = !this.globalOpportunityId && !project.globalDeal ? "LC" : project.globalDeal;
    if (project.globalDeal == "LC" || (!this.globalOpportunityId && project.globalDeal == "LC")) {
      this.deliveryInfoForm.get("globalDeal").setValue(this.globalDealValues[2].value);
      project.globalDealClassification = "";
    }
    this.checkGlobalDealValue(project.globalDeal);
    if (this.c2cDeploymentCountry) {
      this.centralToCentralSelected = true;
    };

    if (this.POR530 || this.POR530_TMC) {
      if(!this.globalDealClassificationValues.some(obj => obj.id === 'C2C'))
      this.globalDealClassificationValues.push(
        { id: "C2C", value: "Central to Central" },
      );
    }

    this.devices = await this.deviceService.getAssets(project.id);

    const uniqueBillingFrequencyValues = this.devices.map(device => device.billingFrequency)
      .filter((value, index, self) => self.indexOf(value) === index);

    this.billingFrequencyValues.forEach((bfVal) => {
      uniqueBillingFrequencyValues.forEach((val) => {
        if (val !== "MNTH" && val === bfVal.id) this.filteredBillingFrequencyValuesDefault.push(bfVal);
      });
    });
    if (this.filteredBillingFrequencyValuesDefault.length) {
      this.billingCycleForm.get("billingFrequencyDefault").setValue(this.filteredBillingFrequencyValuesDefault[0].id);
    }
    this.devices.forEach((device) => {
      if (device.billingFrequency === "MNTH") {
        this.assets.monthly.push(device);
        device.billingCycle = "M01";
      }
    });
    if (this.assets.monthly.length) this.adjustBCMonthlyListHelper();
    
    if (this.por229_1tmc) {
      this.devices.forEach((device) => {
        if (device.billingFrequency === "FTU" && device.chargePlanCombo === "BFTIAD") {
          this.isFtuWithBFTIAD = true;
          device.billingCycle = "FTU";
          this.assets.ftu.push(device);
        }

        if (device.billingFrequency === "FTU" && device.chargePlanCombo !== "BFTIAD") {
          this.assets.ftuBftiad.push(device);
          this.isFtuWithoutBFTIAD = true;
          device.billingCycle = "FTU";
        }
      });
      if (this.assets.ftu.length) this.adjustBCFtuListHelper();
      if (this.assets.ftuBftiad.length) this.adjustBCFtuWithoutBftiadListHelper();
    }
    this.isMpc = project.isMpc;

    if (project.isMpc && project.mpcContactsAddressesBpids) this.setMpcData(project);
    this.isPmpspProject = this.targetSystem === TARGET_SYSTEM.PMPS_PAGE ||
    this.targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_PAGE ||
    this.targetSystem === TARGET_SYSTEM.MP_FLEX_RESELL ||
    this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH;
    if (this.POR530 || this.POR530_TMC) {
      this.deliveryInfoForm.parseProjectJson(project, this.isPmpspProject, null, this.c2cDeploymentCountry);
    } else {
      this.deliveryInfoForm.parseProjectJson(project, this.isPmpspProject);
    }
    if (!project.supplyRoutingId) {
      project.supplyRoutingId = project.ampId;
    }
    this.projectCountry = project.country.countryId;
    this.isRegionIndia = this.billFromService.isregionIndia(project);
    if (this.billFromService.isCentralized(project)) {
      this.billFromAccountsList = await this.billFromService.getBillFromBuildings(
        this.projectId, this.projectCountry,
      );
      // find and check correct building
      const correspondingBillFrom = this.billFromAccountsList.find(
        bf => bf.id === project.billFromBPIDId,
      );
      this.setBillFromAccount(correspondingBillFrom);
      // if ma has been created disable fields
      if (
        project.currentMaStatus !== this.masterAgreementStatusValues.noMasterAgreement.nameShort &&
        project.currentMaStatus !== this.masterAgreementStatusValues.createFailed.nameShort
      ) {
        this.deliveryInfoForm.get("billFromStructure").disable();
        this.deliveryInfoForm.get("selectedBillFrom").disable();
      }
    }
    this.syncContactAndAddressIds();

    this.itsmCustomerId = project.itsmCustomerId;
    this.resellerCustomerId = project.resellerCustomerId;
    this.opportunityId = project.opportunityId || "";
    this.projectRejected = project.rejected;
    this.coTerminous = project.coTerminous;

    this.sourceDocumentationLink = project.sourceDocumentationLink;

    this.filterBillingCycleValues();

    // this.projectAllowsFedLLC = await this.projectService.getFedlLLCAllowedProject(this.projectId);

    // The following two lines are required to populate contract accounts component
    this.customerBpId = this.isPmpspProject ? project.resellerBpId : project.customerBpId;
    this.defaultContractAccountId = this.deliveryInfoForm.getRawValue().defaultContractAccountId;
    this.currentMAStatus = project.currentMaStatus
    if (project.currentMaStatus === this.masterAgreementStatusValues.itsmOnboarded.nameShort) 
    { this.currentStatus = await this.projectService.getMasterAgreementStatus(this.projectId); }
    if ((
      project.currentMaStatus !== this.masterAgreementStatusValues.noMasterAgreement.nameShort &&
      project.currentMaStatus !== this.masterAgreementStatusValues.createFailed.nameShort)
    ) {
      this.isMAActive = true;
      await this.deliveryInfoForm.disable();
      if (project.currentMaStatus === this.masterAgreementStatusValues.itsmOnboarded.nameShort &&
        this.currentStatus && this.currentStatus.productsNeedingExport) {
        this.productsNeedingExport = this.currentMAStatus.productsNeedingExport;
        await this.deliveryInfoForm.controls["purchaseOrderSplit"].enable();
        await this.deliveryInfoForm.controls["billingModelSplit"].enable();
        await this.deliveryInfoForm.controls["businessModelSplit"].enable();
        await this.deliveryInfoForm.controls["chargeTypeSplit"].enable();
        await this.deliveryInfoForm.controls["endUserSplit"].enable();
        await this.deliveryInfoForm.controls["shipToSplit"].enable();
        await this.deliveryInfoForm.controls["titleStatusSplit"].enable();
      }
    }
    if (this.por721) {
      if (project.currentMaStatus === this.masterAgreementStatusValues.itsmOnboarded.nameShort &&
      this.currentStatus.isAppend === true &&
      this.currentStatus.productsNeedingExport) {
        await this.deliveryInfoForm.controls["opgNumber"].enable();
      }
    }
    // this.onChangePoRequired(); // Get these values consistent

    this.loading = false;
  }

  setBillFromAccount(billFrom) {
    this.selectedBillFromAccount = billFrom;
  }

  @handleErrors()
  async ready() {
    const targetSystem = this.workflowService.workflowConfig.targetSystem;
    let por721_tmc = false;
    const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["POR922_TMC", "POR695_TMC"]);
    this.por922TMC = featurePermissions["POR922_TMC"];
    const POR695_TMC = featurePermissions["POR695_TMC"];

    const isTargetSystemValid = false;
    if (isTargetSystemValid) {
      const [featurePermission] = await Promise.all([this.appSettingsService.getFeaturePermission("POR721_TMC")]);
      por721_tmc = featurePermission;
    }
    this.por721 = por721_tmc;
    this.requiredFlags = {...this.requiredFlags, POR695_TMC};
    this.loadProject();
  }

  @toggleLoading()
  @handleErrors()
  async autoSave(): Promise<boolean> {
    if (
      !this.deliveryInfoForm.getRawValue().orderAcceptance &&
      !this.deliveryInfoForm.controls["orderAcceptanceDisableReason"].value
    ) {
      const message = await this.dialogService.showDialog(
        DisableOrderAcceptanceDialogComponent,
        {message: ""},
        {backdropColor: "rgba(0, 0, 0, 0.5)"},
      );

      if (message) {
        this.deliveryInfoForm.controls["orderAcceptanceDisableReason"].setValue(message);
      } else {
        this.error = new Error("A reason is required in order to disable order acceptance");
        return false;
      }
    }
    if (!this.por229_1tmc && this.deliveryInfoForm.get("prepaidFieldOnDorTab").value === "P") {
      this.error = new Error("Prepaid Field on DOR Tab is required in DOR Data");
      return false;
    }
    if (this.caDetails.pendingCAExists) {
      this.error = new Error(CONTRACT_ACCOUNT_ERROR_MESSAGES.PENDINGCA);
      return false;
    }
    let chkMapping = this.contractAccountsForm.checkCAMappingRequired();
    if (chkMapping === false) {
      this.error = new Error(CONTRACT_ACCOUNT_ERROR_MESSAGES.MAPPINGCA);
      return false;
    }
    if (!this.caDetails.activeCAExists) {
      this.error = new Error(CONTRACT_ACCOUNT_ERROR_MESSAGES.CREATECA);
      return false;
    }
    if (this.por721) {
      let opgNumberError = false;
      this.devices.forEach((device) => {
        if (device.bundleNumbers && device.bundleNumbers.length > 0) {
          if (!this.deliveryInfoForm.controls["opgNumber"].value) {
            opgNumberError = true;
          }
        }
      });
      if (opgNumberError) {
        this.error = new Error("Big Deal ID is required");
        return false;
      }
    }

    const targetSystemsWithNoCoTermDateValidation = [TARGET_SYSTEM.MP_FLEX_RESELL, TARGET_SYSTEM.MIGRATION_IPSO_PAGE,
      TARGET_SYSTEM.PMPS_PAGE, TARGET_SYSTEM.PMPS_COMPLETE, TARGET_SYSTEM.MIGRATION_IPSO_COMPLETE];
    if (this.deliveryInfoForm.controls["coTerminous"].value) {
      if (!this.deliveryInfoForm.controls["coTerminousDatePicker"].value &&
        (!targetSystemsWithNoCoTermDateValidation.includes(this.targetSystem))) {
        this.error = new Error("The value in Coterminous End Date is required.");
        return false;
      }
    }

    this.loading = true;

    // if region is india and no Bill-From structure has been chosen
    if (this.isRegionIndia) {
      if (!this.deliveryInfoForm.get("billFromStructure").value) {
        this.error = new Error("A Bill-From structure must be chosen for this region.");
        return false;
      }
      if ( // chose Centralized but no selected BillFrom account
        this.isCentralizedStructured &&
        this.billFromAccountsList && this.billFromAccountsList.length > 0 &&
        !this.selectedBillFromAccount
      ) {
        this.error = new Error("A Bill-From Account must be selected ");
        return false;
      }
    }
    this.deliveryInfoForm.get("billFromBPIDId").setValue(this.selectedBillFromAccount ? this.selectedBillFromAccount.id : null);
    this.removeExtraSpacesFromForm(this.fieldsToTrim);

    const {project} =
      this.deliveryInfoForm.exportDeliveryOpsInformation(this.projectId);

    // Selection for a global deal must be made
    if (!this.deliveryInfoForm.get("globalDeal").value) {
      this.error = new Error("A selection must be made for Global Deal.");
      return false;
    }

    // if global deal is not local and no selection has been made for global deal classification
    if (this.gdClassificationRequired) {
      const gdClassificationVal = this.deliveryInfoForm.get("globalDealClassification").value;
      if (!gdClassificationVal || gdClassificationVal == "NA") {
        this.error = new Error("A selection must be made for Global Deal Classification.");
        return false;
      }
      if (gdClassificationVal === "L2L" && !this.isMAActive && project.soldToAddressId &&
        this.projectCountry !== this.soldToAddresses.find(e => e.id === project.soldToAddressId).country) {
        this.error = new Error(`Selected Global Deal Classification value "Local to Local" is invalid since the Sold-To BPID is of a different country than the local entity. Please make a correct selection for Global Deal Classification.`);
        return false;
      }
    } else {
      project.globalDealClassification = "NA";
    }

    const status = await this.updateBillingCycle();
    if (!status) {
      return false;
    }
    

    this.gdclass = this.deliveryInfoForm.getRawValue().globalDealClassification;
    if ((this.POR530 || this.POR530_TMC) && this.gdclass === 'C2C') {
      let c2cDeloyedCountry = this.deliveryInfoForm.getRawValue().deployementCountry;
      if (!this.deliveryInfoForm.get("deployementCountry").value) {
        this.error = new Error("A selection must be made for Select Deployment Country.");
        return false;
      }
      await this.globalDealSettingsService.setC2cDeployedCountry(this.projectId, c2cDeloyedCountry);
    }

    if (this.por922TMC) {
      project.legacyReportedDate = "2099-12-31";
      project.legacyReportedThruDate = "2099-12-31";
      project.legacyDocumentType = "NONE";
      project.legacyDocumentNumber = "0";
      project.previousDocument = "0000000";
      project.renewal = "O";
    }

    if (
      this.currentMAStatus !== this.masterAgreementStatusValues.masterAgreementActive.nameShort ||
      this.currentMAStatus === this.masterAgreementStatusValues.itsmOnboarded.nameShort
    ) {
      project.productsNeedingExport = this.currentStatus ? this.currentStatus.productsNeedingExport : 0;
      let result;
      if (this.currentMAStatus === this.masterAgreementStatusValues.itsmOnboarded.nameShort &&
        this.currentStatus && this.currentStatus.productsNeedingExport && 
        (project.purchaseOrderSplit || 
          (this.por721 && this.currentStatus.isAppend === true && this.deliveryInfoForm.controls["opgNumber"].value))){
        let resp = await this.projectService.saveInvoiceSplitInfo(project).toPromise();
      }      
      else if (this.checkDirty() ||
      (this.currentMAStatus !== this.masterAgreementStatusValues.masterAgreementActive.nameShort &&
        this.currentMAStatus !== this.masterAgreementStatusValues.itsmOnboarded.nameShort))
      {result = await this.projectService.saveDeliveryOpsInfo(project).toPromise();}
    }
   
    if (this.selectedCa && this.selectedCa.length > 0) {
      // save contract accounts selection changes to ITSM
      const contractAccounts = this.selectedCa;
      const response = await this.projectService.saveContractAccountsAssociation(
        project.id, contractAccounts, project.opportunityId || this.opportunityId,
      );
      if (response) {
        this.contractAccountsForm.reloadContractAccounts();
        if (response.success === false) {
          this.contractAccountsForm.error = new Error(response.message);
          return false;
        }
      }
    }

    if (project.currentMaStatus === "MA accepted" && this.workflowService.nextStep.status === 4) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.InProgress, "createGerpContract");
      this.workflowService.navigate(
        undefined,
        WorkflowNavigationDirection.Manual,
        this.workflowService.workflowConfig.steps.find(it => it.stepName === "createGerpContract"),
      );
      return true;
    }

    // Saving Purchase Orders
    await this.purchaseOrderCardComponent.savePurchaseOrders();
    const saLetter = this.deliveryInfoForm.getRawValue().saLetter;

    if (this.deliveryInfoForm.controls["saLetter"].dirty && saLetter) {
      await this.projectService.sendSaLetterToITSM(saLetter, this.projectId);
    }

    if (this.deliveryInfoForm.getRawValue().orderAcceptance) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
      return true;
    }

    this.loading = false;
    await this.workflowService.setStepStatus(WorkflowStepStatus.Blocked);
    return false;
  }

  checkDirty(): boolean {
    return (this.workflowService.getCurrentStepStatus() < WorkflowStepStatus.Completed) || this.deliveryInfoForm.dirty ||
    this.purchaseOrderCardComponent.isDirty
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private projectService: ProjectService,
    private dialogService: DialogService,
    private contactService: ContactService,
    private appSettingsService: AppSettingsService,
    public deviceService: DeviceService,
    public billFromService: BillFromService,
    private fb: FormBuilder,
    private globalDealSettingsService: GlobalDealSettingsService,
    private hasuraGraphqlService: HasuraGraphqlService,
  ) {
    super();
    this.subscription = appSettingsService.settings.subscribe((settings) => {
      this.enablePurchaseOrdersFlag = settings.enablePurchaseOrders;
    });
    this.appSettingsService.getDeployementCountry().subscribe((countries) => {
      this.countries = countries
    });
  }

  public rejectProject(): void {
    RejectProjectDialogComponent.showRejectProjectDialogModal(
      this.dialogService,
      {
        projectId: this.projectId,
        workflowId: this.workflowService.workflowConfig.id,
      },
    )
      .subscribe((result: any) => {
        if (result.success) {
          // navigate to the Projects screen (The CA is done with this project)
          this.router.navigate(["/projects"])
            .catch((error) => {
              console.error(error);
            });
        }
      });
  }

  public DPToTxt(param): void {
    const date = this.deliveryInfoForm.getRawValue()[`${param}Picker`];
    this.deliveryInfoForm.controls[param].setValue(date);
  }

  get notCA() {
    return this.workflowService.userHasPrivilege("contract-administrator") ? null : "disabled";
  }

  public async purchaseOrdersExist(doPosExist: boolean) {
    if (doPosExist) await this.deliveryInfoForm.controls["purchaseOrderSplit"].disable();
    else await this.deliveryInfoForm.controls["purchaseOrderSplit"].enable();
  }

  public contractAccountDetails(pendingCADetails: any) {
    this.caDetails = pendingCADetails;
    if (!this.warningMessage && this.caDetails.pendingCAExists) {
      this.warningMessage = CONTRACT_ACCOUNT_ERROR_MESSAGES.PENDINGCA;
    } else this.warningMessage = "";
  }

  public mappedContractAccounts(selectedContractAccounts: any){
    this.selectedCa = selectedContractAccounts;
  }

  @handleErrors()
  public async selectContact(selectedTmcContactId, contactType): Promise<void> {
    const allowCreate = false;
    const requireBpId = true;

    const modalResults = await (SelectItsmContactDialogComponent.showContactModal(
      this.dialogService,
      {
        projectId: this.projectId,
        contactService: this.contactService,
        allowCreate,
        requireBpId,
        selectedTmcContactId,
        itsmContacts: this.contactTypes[contactType],
        titleModifier: this.contactHumanReadableNames[contactType],
      },
    ));

    if (modalResults.changed) {
      switch (contactType) {
        case this.settableContacts.billTo:
          this.deliveryInfoForm.controls["billToContactId"].setValue(modalResults.selectedContactId);
          break;
        case this.settableContacts.invoice:
          this.deliveryInfoForm.controls["invoiceContactId"].setValue(modalResults.selectedContactId);
          break;
        case this.settableContacts.hpInvoice:
          this.deliveryInfoForm.controls["hpInvoiceContactId"].setValue(modalResults.selectedContactId);
          break;
        case this.settableContacts.sales:
          this.deliveryInfoForm.controls["hpSalesRepContactId"].setValue(modalResults.selectedContactId);
          break;
        case this.settableContacts.contractAdmin:
          this.deliveryInfoForm.controls["hpContractAdminContactId"].setValue(modalResults.selectedContactId);
          break;
        case this.settableContacts.accDelMgr:
          this.deliveryInfoForm.controls["hpAccDeliveryMgrContactId"].setValue(modalResults.selectedContactId);
          break;
        default:
          throw new Error(`unrecognized contact ${contactType}`);
      }

      this.syncContactAndAddressIds();
    }
  }

  keydowned(e) {
    const rgx = new RegExp("[e\\.\\-\\+]", "gi");
    if (e.key.length === 1 && rgx.test(e.key)) {
      e.preventDefault();
    }
  }

  public async changedBillFrom() {
    this.billFromAccountsList = undefined;
    this.selectedBillFromAccount = undefined;
    if (this.isCentralizedStructured) {
      this.loadingBillFromList = true;
      this.billFromAccountsList = await this.billFromService.getBillFromBuildings(this.projectId, this.projectCountry);
      this.loadingBillFromList = false;
    }
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
    super.ngOnDestroy();
  }
}
